import request from '@/utils/request'
import requestBluepay from '@/utils/request-bluepay'

// 获取代付渠道列表
export function fetchDisburseBankList(params = {}) {
  return request({
    url: '/order/institute/instituteNameList',
    method: 'get',
    params
  })
}

// 获取账户总览数据
export function fetchAccountOverview(params = {}) {
  return request({
    url: '/mchApps',
    method: 'get',
    params
  })
}

// 获取会计总览具体余额数据
export function fetchOverview(params = {}) {
  return request({
    url: '/merchant-api/trade/overview',
    method: 'get',
    params
  })
}

// 获取对应日期的会计总览列表数据
export function fetchSettOverviewAllList(data = {}) {
  return request({
    url: '/settlement/daily/statistics/paymentAllList',
    method: 'post',
    data
  })
}

// 获取的代付明细列表数据
export function fetchPayoutDetailInfo(data = {}) {
  return request({
    url: '/merchant-api/transaction/getDisbursementList',
    method: 'post',
    data
  })
}

// 获取代付明细列表数据 用于下载
export function fetchPayoutDetailInfoAllList(data = {}) {
  return request({
    url: '/merchant-api/fileDownload/merchantDownloadDisbursementFile/async',
    method: 'post',
    timeout: 60000,
    data
  })
}

// 获取的支付明细列表数据
export function fetchPaymentDetailInfo(data = {}) {
  return request({
    url: '/merchant-api/transaction/getPaymentList',
    method: 'post',
    data
  })
}

// 获取支付明细列表数据 用于下载
export function fetchPaymentDetailInfoAllList(data = {}) {
  return request({
    url: '/merchant-api/fileDownload/merchantDownloadPaymentFile/async',
    method: 'post',
    timeout: 60000,
    data
  })
}

// 获取的余额记录列表数据
export function fetchMchBalanceInfo(data = {}) {
  return request({
    url: '/merchant-api/balance/info',
    method: 'post',
    data: data
  })
}

// 获取余额记录列表数据 用于下载
export function fetchMchBalanceInfoAllList(data = {}) {
  return request({
    url: '/merchant-api/balance/list',
    method: 'post',
    data: data
  })
}

// 获取的提现明细记录列表数据
export function fetchMchWithdrawInfo(data) {
  return request({
    url: '/merchant-api/mchWithdraw/mchWithdrawInfo',
    method: 'post',
    data: data
  })
}

// 提现明细列表数据 用于下载
export function fetchMchWithdrawInfoAllList(data) {
  return request({
    url: '/merchant-api/mchWithdraw/mchWithdrawInfoList',
    method: 'post',
    data: data
  })
}

// 获取充值记录列表数据
export function fetchMchRechargeList(data = {}) {
  return request({
    url: '/merchant-api/recharge/list',
    method: 'post',
    data: data
  })
}

// 获取充值记录列表数据 用于下载
// export function fetchMchRechargeInfoAllList(params = {}) {
//   return request({
//     url: '/merchant-api/recharge/list',
//     method: 'get',
//     params
//   })
// }

// 获取转账列表
export function fetchMchtransferList(data = {}) {
  return request({
    url: '/merchant-api/trade/relate/transferList',
    method: 'post',
    data: data
  })
}

// 余额汇总
export function fetchBalanceSummaryDetail(data = {}) {
  return request({
    url: '/merchant-api/balance/summary',
    method: 'post',
    data: data
  })
}

export function paymentRefundList(data = {}) {
  return request({
    url: '/merchant-api/payment/refund/list',
    method: 'post',
    data
  })
}

export function goToOpenApiBluepayThaiDynamicQr(params = {}) {
  return requestBluepay({
    url: '/merchant-api/mch/recharge/goToOpenApiBluepayThaiDynamicQr',
    method: 'get',
    params
  })
}

export function pageForeignExchange(data = {}) {
  return request({
    url: '/merchant-api/transaction/pageForeignExchange',
    method: 'post',
    data
  })
}

export function getCreditLoanList(data = {}) {
  return request({
    url: '/merchant-api/transaction/getCreditLoanList',
    method: 'post',
    data
  })
}

export function pageForeignExchangeDownload(data = {}) {
  return request({
    url: '/merchant-api/fileDownload/foreignExchange/async',
    method: 'post',
    data
  })
}

export function queryForeignExchangeRate(data = {}) {
  return request({
    url: '/merchant-api/foreignExchange/rate',
    method: 'post',
    data
  })
}

export function getCreditLoanOrderDetail(params = {}) {
  return request({
    url: '/merchant-api/transaction/getCreditLoanOrderDetail',
    method: 'get',
    params
  })
}

export function getCreditLoanDetail(params = {}) {
  return request({
    url: '/merchant-api/transaction/getCreditLoanDetail',
    method: 'get',
    params
  })
}

export function getCreditRepaymentList(data = {}) {
  return request({
    url: '/merchant-api/transaction/getCreditRepaymentList',
    method: 'post',
    data
  })
}

export function nsdsBillPage(data = {}) {
  return request({
    url: '/merchant-api/mch/nsds/bill/page',
    method: 'post',
    data
  })
}
export function fileDownloadNsdsBillPage(data = {}) {
  return request({
    url: '/merchant-api/fileDownload/bill/async',
    method: 'post',
    data
  })
}

export function preCalculate(data = {}) {
  return request({
    url: '/merchant-api/mch/nsds/bill/preCalculate',
    method: 'post',
    data
  })
}

// 取消提现
export function mchWithdrawCancel(data = {}) {
  return request({
    url: '/merchant-api/mchWithdraw/cancel',
    method: 'post',
    data
  })
}

// 商户获取提现记录接口 (国际系统专用)
export function fetchPageMchWithdrawInfo(data) {
  return request({
    url: '/merchant-api/mchWithdraw/pageMchWithdraw',
    method: 'post',
    data: data
  })
}

// 提现明细列表数据 用于下载 (国际系统专用)
export function fetchDownloadMchWithdraw(data) {
  return request({
    url: '/merchant-api/mchWithdraw/downloadMchWithdraw',
    method: 'post',
    data: data
  })
}

// 获取提现详情
export function fetchMchWithdrawDetail(params = {}) {
  return request({
    url: '/merchant-api/mchWithdraw/detail',
    method: 'get',
    params: params
  })
}

// 返回俄罗斯商户的本币提现金额门槛
export function getWithdrawThreshold(params = {}) {
  return request({
    url: '/merchant-api/mchWithdraw/getWithdrawThreshold',
    method: 'get',
    params: params
  })
}

// 商户确认报价接口
export function fetchConfirmPricing(data) {
  return request({
    url: '/merchant-api/mchWithdraw/confirmPricing',
    method: 'post',
    data: data
  })
}

// 提现详情商户上传发票文件
export function fetchUploadInvoice(data) {
  return request({
    url: '/merchant-api/mchWithdraw/uploadInvoice',
    method: 'post',
    data: data
  })
}
